/** Autorizações efetivas SCA (perfil → função → auth). */

function normalizeCode(code) {
  return String(code ?? "")
    .trim()
    .toUpperCase();
}

/** Conjunto de códigos de autorização efetivos. */
export function authorizationSet(user) {
  const list = Array.isArray(user?.authorizations) ? user.authorizations : [];
  return new Set(list.map(normalizeCode).filter(Boolean));
}

/** True se o utilizador tem o código (ex.: SCA_USER_RD). */
export function userHasAuth(user, code) {
  if (code == null || code === "") return true;
  return authorizationSet(user).has(normalizeCode(code));
}

/**
 * True se tem pelo menos um dos códigos.
 * @param {object|null} user
 * @param {string|string[]} codes
 */
export function userHasAnyAuth(user, codes) {
  if (codes == null || codes === "") return true;
  const list = Array.isArray(codes) ? codes : [codes];
  if (list.length === 0) return true;
  const set = authorizationSet(user);
  return list.some((c) => set.has(normalizeCode(c)));
}
